const CACHE_SCHEMA_VERSION = 1;
const CACHE_PREFIX = "imao-store";

const cacheKey = (storeId, name) => `${CACHE_PREFIX}:${storeId}:${name}`;

const readJSON = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};

const writeJSON = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Cache writes should not block ordering if browser storage is unavailable.
  }
};

export const readCachedStoreData = (storeId) => ({
  metadata: readJSON(cacheKey(storeId, "metadata")),
  store: readJSON(cacheKey(storeId, "store")),
  products: readJSON(cacheKey(storeId, "products")),
});

export const writeCachedMetadata = (storeId, metadata) => {
  writeJSON(cacheKey(storeId, "metadata"), {
    schema_version: CACHE_SCHEMA_VERSION,
    store_version: Number(metadata?.store_version || 0),
    product_version: Number(metadata?.product_version || 0),
  });
};

export const writeCachedStore = (storeId, store) => {
  writeJSON(cacheKey(storeId, "store"), store);
};

export const writeCachedProducts = (storeId, products) => {
  writeJSON(cacheKey(storeId, "products"), products);
};

export const isCacheMetadataCurrent = (cachedMetadata, metadata) => {
  if (!cachedMetadata || cachedMetadata.schema_version !== CACHE_SCHEMA_VERSION) {
    return false;
  }

  return (
    Number(cachedMetadata.store_version || 0) === Number(metadata?.store_version || 0) &&
    Number(cachedMetadata.product_version || 0) === Number(metadata?.product_version || 0)
  );
};

export const isCachedStoreCurrent = (cachedMetadata, metadata) =>
  cachedMetadata?.schema_version === CACHE_SCHEMA_VERSION &&
  Number(cachedMetadata.store_version || 0) === Number(metadata?.store_version || 0);

export const isCachedProductsCurrent = (cachedMetadata, metadata) =>
  cachedMetadata?.schema_version === CACHE_SCHEMA_VERSION &&
  Number(cachedMetadata.product_version || 0) === Number(metadata?.product_version || 0);
